<template>
    <div class="acao">
        <button class="lb-button-acao dropdown-toggle-custom" @click="toggleDropdown" @blur="onBlur">
            <b-icon v-if="iconeLista" icon="list" />
            <i v-else class="fa fa-ellipsis-v fa-fw"></i>
        </button>

        <div v-if="isOpen" class="dropdown-menu-custom" :style="dropdownStyle">
            <div class="dropdown-header" v-if="!iconeLista">
                Escolha uma ação
            </div>
            <div v-for="(action, index) in actions" :key="index">
                <div v-if="!action.show || action.show(itemRecord)">
                    <hr v-if="action.type === 'divider'" class="dropdown-divider" />
                    <button v-if="action.type === 'function'" class="dropdown-item-custom"
                        @click="executeAction(action.acao, itemRecord)">
                        <b-icon v-if="action.icon" :icon="action.icon" aria-hidden="true" />
                        {{ action.label }}
                    </button>
                    <button v-if="action.type === 'gerarPdf'" class="dropdown-item-custom"
                        @click="gerarPdf(action.acao, itemRecord)">
                        <b-icon v-if="action.icon" :icon="action.icon" aria-hidden="true" />
                        {{ action.label }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { geradorDePdf } from "./utils/geradorDePdf";

export default {
    inheritAttrs: false,
    props: {
        iconeLista: Boolean,
        actions: {
            type: Array,
            default: () => [],
        },
        itemRecord: Object,
        cols: String,
        sm: String,
        md: String,
        classFormGroup: {
            type: String,
            default: "",
        },
        label: String,
        isPdf: Boolean,
        casePdf: String,
        isXls: Boolean,
        caseXls: String,
    },
    data() {
        return {
            responsiveCols: "",
            isOpen: false,
            dropdownStyle: {},
        };
    },
    mounted() {
        this.responsiveCols = [
            this.cols ? `col-${this.cols}` : "",
            this.sm ? `col-sm-${this.sm}` : "",
            this.md ? `col-md-${this.md}` : "",
        ]
            .filter(Boolean)
            .join(" ") || "col-12";

        // Adicionar listener para scroll
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        // Remover listener quando componente for destruído
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            // Reposicionar dropdown quando houver scroll
            if (this.isOpen) {
                this.positionDropdown();
            }
        },
        toggleDropdown() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                this.$nextTick(() => {
                    this.positionDropdown();
                });
            }
        },
        positionDropdown() {
            const button = this.$el.querySelector('.dropdown-toggle-custom');
            if (button) {
                const buttonRect = button.getBoundingClientRect();
                const viewportWidth = window.innerWidth;

                // Calcular posição à esquerda do botão
                let left = buttonRect.left - 220; // 220px é a largura do dropdown

                // Se não couber à esquerda, posicionar à direita
                if (left < 10) {
                    left = buttonRect.right + 5;
                }

                // Se não couber à direita, centralizar
                if (left + 220 > viewportWidth - 10) {
                    left = buttonRect.left - 110; // Centralizar
                }

                this.dropdownStyle = {
                    position: 'fixed',
                    left: left + 'px',
                    top: (buttonRect.bottom + 5) + 'px',
                    zIndex: '9999'
                };
            }
        },
        onBlur() {
            // Fechar dropdown quando perder foco
            setTimeout(() => {
                this.isOpen = false;
            }, 150);
        },
        executeAction(acao, itemRecord) {
            if (typeof acao === "function") {
                acao(itemRecord);
            }
            this.isOpen = false;
        },
        async gerarPdf(acao, itemRecord) {
            if (typeof acao === "function") {
                const dadosParaOPdf = await acao(itemRecord);
                geradorDePdf(dadosParaOPdf, this.casePdf);
            }
            this.isOpen = false;
        },
    },
};
</script>

<style>
.lb-button-acao {
    background-color: transparent !important;
    color: #66615b !important;
    border-color: transparent !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
    cursor: pointer !important;
}

.dropdown-toggle-custom {
    background-color: transparent !important;
    color: #66615b !important;
    border: 1.5px solid var(--color-primary) !important;
    border-radius: 50% !important;
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
    min-height: 24px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
    margin: 0 2px !important;
    font-size: 14px !important;
    transition: color 0.18s, border-color 0.18s !important;
    box-shadow: none !important;
    vertical-align: middle !important;
    cursor: pointer !important;
}

.dropdown-toggle-custom:hover {
    background: var(--color-primary) !important;
    color: #fff !important;
    border-color: var(--color-primary) !important;
}

.dropdown-menu-custom {
    position: fixed !important;
    background: #fff !important;
    border: 1px solid #e3e6f0 !important;
    border-radius: 8px !important;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15), 0 2px 10px rgba(0, 0, 0, 0.1) !important;
    min-width: 220px !important;
    max-height: 350px !important;
    overflow-y: auto !important;
    z-index: 9999 !important;
    padding: 4px 0 !important;
    backdrop-filter: blur(10px) !important;
    -webkit-backdrop-filter: blur(10px) !important;
}

.dropdown-header {
    padding: 10px 16px 8px 16px !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    color: #6c757d !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    border-bottom: 1px solid #f1f3f4 !important;
    margin-bottom: 4px !important;
    background: #fafbfc !important;
    border-radius: 8px 8px 0 0 !important;
}


.dropdown-item-custom:hover {
    background: var(--color-primary) !important;
    color: #fff !important;
    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3) !important;
}

.dropdown-item-custom:active {
    transform: translateX(1px) scale(0.98) !important;
}


.dropdown-item-custom:hover svg {
    opacity: 1 !important;
    transform: scale(1.1) !important;
}

.dropdown-divider {
    height: 0 !important;
    margin: 8px 16px !important;
    overflow: hidden !important;
    border-top: 1px solid #e9ecef !important;
    position: relative !important;
}

.dropdown-divider::before {
    content: '' !important;
    position: absolute !important;
    top: -1px !important;
    left: 20% !important;
    right: 20% !important;
    height: 1px !important;
    background: linear-gradient(90deg, transparent, #dee2e6, transparent) !important;
}

/* Scrollbar customizada */
.dropdown-menu-custom::-webkit-scrollbar {
    width: 6px !important;
}

.dropdown-menu-custom::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
    border-radius: 3px !important;
}

.dropdown-menu-custom::-webkit-scrollbar-thumb {
    background: var(--color-primary) !important;
    border-radius: 3px !important;
}

.dropdown-menu-custom::-webkit-scrollbar-thumb:hover {
    background: var(--color-primary-dark, #0056b3) !important;
}


.dropdown-item-custom {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-start !important;
    gap: 8px !important;
    width: 100% !important;
    padding: 8px 16px !important;
    font-size: 13px !important;
    color: #495057 !important;
    text-align: left !important;
    background: none !important;
    border: none !important;
    cursor: pointer !important;
    transition: all 0.2s ease-in-out !important;
    border-radius: 0 !important;
    margin: 0 !important;
    position: relative !important;
    white-space: nowrap !important;
    min-height: 36px !important;
}

.dropdown-item-custom svg {
    margin: 0 !important;    width: 16px !important;
    height: 16px !important;
    opacity: 0.8 !important;
    transition: all 0.2s ease-in-out !important;
    flex-shrink: 0 !important;
}


</style>